export const CASE_SUBMIT_KEY = 'case_submit_times';
